<app-floorplan-item-details
  [floorplanItem]="wire()"
  [extent]="extent()"
  [isExtendable]="true"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    @if (wireForm) {
      <form odxForm [formGroup]="wireForm" [disabled]="wire().locked">
        <odx-form-field i18n-label="@@floorplan.details.wire.form.name.label" label="Name">
          <input
            formControlName="name"
            odxFormFieldControl
            i18n-placeholder="@@floorplan.details.wire.form.name.placeholder"
            placeholder="Name"
          />
        </odx-form-field>
      </form>
    }
    <app-reference-measurement-item-length [floorplanItem]="wire()"></app-reference-measurement-item-length>
  </div>
  <div data-extended>
    <div odxLayout="flex" class="flex-column">
      <h5 i18n="@@floorplan.details.wire.extendedNotes.title" class="odx-title-5">Spezifikationen</h5>
      @if (wireForm) {
        <form odxForm [formGroup]="wireForm" [disabled]="wire().locked">
          <odx-form-field i18n-label="@@floorplan.details.wire.form.type.label" label="Art">
            <input
              formControlName="type"
              odxFormFieldControl
              i18n-placeholder="@@floorplan.details.wire.form.type.placeholder"
              placeholder="Art"
            />
          </odx-form-field>
          <odx-form-field i18n-label="@@floorplan.details.wire.form.diameter.label.deprecated" label="Länge (Deprecated)">
            <input
              formControlName="scalingLength"
              odxFormFieldControl
              i18n-placeholder="@@floorplan.details.wire.form.scalingLength.placeholder.deprecated"
              placeholder="Länge"
              [odxTooltip]="tooltipTextDeprecatedLength"
              [readonly]="true"
            />
          </odx-form-field>
        </form>
      }
    </div>
  </div>
</app-floorplan-item-details>
